import React from 'react';
import { Segment, Divider, Dropdown, Button, Form, Icon, Menu, Checkbox, TextArea, Message } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { isPanelChangePeriod } from '../../util/helpers'

/**
 * Edit panel target data component
 */
export default class EditPanelTarget extends React.Component {	

	/**
     * Constructor
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
			frequencyChangeChecked: false,
			changed: false,
			isPanelOpen: false
        }
	}	
	
	handleFrequencyChange = () => this.setState((prevState) => ({ ...prevState, changed: true, frequencyChangeChecked: !prevState.frequencyChangeChecked }))

	handleTargetgroupChange = (e, { value }) => {
		var textContent = e.target.textContent;
		this.setState((prevState) => ({ ...prevState, changed: true, newmypreferredspecialtyen: value, newmypreferredspecialtyhu: textContent })
	)}
	/**
	 * Save modifications
	 */
	handleSaveModification = () => {
		var license = this.props.match.params.license;
		if (this.state.frequencyChangeChecked)
		{
			var reason = document.getElementById('target.frequencyReason').value;

			if (reason.length !== 0)
			{
				this.props.savePanelChange(this.props.visitorTerritory, license, reason, undefined, undefined, undefined);
			}
			else
			{
				alert('Frekvenciaváltoztatás igényléséhez indokolnod kell kérésedet.');
			}
		}
		else
		{
			if (this.state.changed)
			{			
				// Segmentation is no longer user-editable, send 'NA' or keep undefined
				this.props.savePanelChange(this.props.visitorTerritory, license, undefined, 'NA', this.state.newmypreferredspecialtyen, this.state.newmypreferredspecialtyhu);
			}
			else
			{
				alert('Nem változtattál semmit, kattints a Mégse gombra a főoldalra való visszatéréshez.');
			}	
		}
	}

	/**
	 * Get target information (to know the 3 specialty)
	 */
	componentDidMount() 
	{
		// Get license
		const license = this.props.match.params.license;

		// Addresses
		this.props.fetchTargetAddresses(license);
		
		// Target
		const tempTarget = (this.props.actualPanel === undefined ? undefined : this.props.actualPanel.filter( x => x.license === license )[0]);
		if (tempTarget !== undefined)
		{
			this.props.fetchTarget(tempTarget.license);

			// Set original specialty and segmentation for this target
			this.setState({ ...this.state, newmypreferredspecialtyen: tempTarget.myPreferredSpecialtyEn, newmypreferredspecialtyhu: tempTarget.myPreferredSpecialtyHu, newsegmentation: tempTarget.segmentation });
		}

		// Initialize target group list 
		if (this.props.targetgroups.length === 0)
		{
			this.props.fetchTargetgroups();
		}

		// Panel modification period?
		if (!isPanelChangePeriod() && !this.props.isPanelOpen)
		{
			this.setState({ ...this.state, frequencyChangeChecked: true });
		}
	}

	render() {
		const license = this.props.match.params.license;
		const panelTarget = (this.props.actualPanel === undefined ? undefined : this.props.actualPanel.filter( x => x.license === license )[0]);

		return  panelTarget === undefined ?
				<Segment>Térj vissza a nyitóoldalra.</Segment>
				:
				this.props.actualTargetgroups.length === 0
				?
				'Betöltés...'
				:
				<Segment basic loading={ this.props.isLoading }>
                    { this.props.errorTarget === undefined ? '' : <Message error>Hiba történt. { this.props.errorTarget }</Message> }
                    { this.props.errorPanel === undefined ? '' : <Message error>Hiba történt. { this.props.errorPanel }</Message> }					
                    { this.props.errorPanelChange === undefined ? '' : <Message error>Hiba történt. { this.props.errorPanelChange }</Message> }					
					<h3><Icon name='edit'/>Célpont módosítása</h3>
					<h4>{ panelTarget.name }</h4>
					{
						this.props.addresses.map( (a, index) => {
							return <span key={ index }><b>{ a.city }</b>, { a.postalCode }, { a.address }<br/></span>
						})
					}
					<Divider/>
				<Form>
					{ 
						this.state.frequencyChangeChecked ?
						''
						:						
						<Form.Field>
							<label>Új szakterület</label>
							<Menu compact>
								<Dropdown onChange={ this.handleTargetgroupChange } 
										  selection
										  options={this.props.actualTargetgroups} 
										  id='target.specialty' 
										  defaultValue={ panelTarget.myPreferredSpecialtyEn } 
										  item />
							</Menu>
						</Form.Field>
					}
					<Form.Field>
						<label>Frekvenciaváltoztatás kérése</label>
						<Checkbox style={{ 'paddingTop': '3px' }} onChange={ this.handleFrequencyChange } checked={ this.state.frequencyChangeChecked }>
						</Checkbox>
							<span style={{ 'color': this.state.frequencyChangeChecked ? 'inherit' : '#aaa' }}>
								&nbsp; Igen, kérem a célpont ciklusra vonatkozó frekvencia változtatását az alábbi indokkal és az alábbi időponttól (<b>időpont megadás kötelező</b>):
							</span>
							{
								this.state.frequencyChangeChecked
								?
								<TextArea id='target.frequencyReason' />
								:
								''
							} 
						</Form.Field>	
						<Link to='/panelChanges'><Button basic primary>Mégse</Button></Link>
						<Button onClick={ this.handleSaveModification } floated='right' primary><Icon name='check' /> Mentés</Button>
					</Form>
				</Segment>
	}
}